export const whatsappNumber = '5511948951961';

const messages = {
  industria: 'Olá estou na página de Atacado da Sustenta LED, sou do setor indústria e preciso de atendimento. Com quem falo?',
  comercio: 'Olá estou na página de Atacado da Sustenta LED, sou do setor comércio e preciso de atendimento. Com quem falo?',
  revendedor: 'Olá estou na página de Atacado da Sustenta LED, sou revendedor e preciso de atendimento. Com quem falo?',
  licitante: 'Olá estou na página de Atacado da Sustenta LED, sou licitante e preciso de atendimento. Com quem falo?',
  loja: 'Olá estou na página de Atacado da Sustenta LED, tenho loja de iluminação e preciso de atendimento. Com quem falo?',
  empresa: 'Olá estou na página de Atacado da Sustenta LED, represento uma empresa e preciso de atendimento. Com quem falo?',
  condominio: 'Olá, sou de um condomínio e preciso de soluções de iluminação LED. Pode me ajudar?',
  construtora: 'Olá, represento uma construtora e preciso de atendimento especializado em LED.',
  materiais: 'Olá, sou de uma loja de materiais elétricos e preciso de cotação de LED.',
  decorador: 'Olá, sou decorador e preciso de luminárias LED para projeto.',
  arquiteto: 'Olá, sou arquiteto e preciso de soluções de LED para um projeto.',
  engenheiro: 'Olá, sou engenheiro e preciso de iluminação LED técnica para obra.',
  mestre: 'Olá, sou mestre de obras e preciso de iluminação LED para obra.',
  igreja: 'Olá, represento uma igreja e preciso de iluminação LED.',
  posto: 'Olá, represento um posto de combustível e preciso de iluminação LED.',
  outro: 'Olá, preciso de atendimento para soluções em LED.'
};

export function generateWhatsAppLink(clientType, utmSource = clientType) {
  const message = encodeURIComponent(messages[clientType] || messages.outro);
  return `https://wa.me/${whatsappNumber}?text=${message}&utm_source=website&utm_medium=whatsapp&utm_campaign=wpp-${utmSource}-link`;
}

export function generateWhatsAppMessageLink(message, utmSource = 'contato') {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${whatsappNumber}?text=${encodedMessage}&utm_source=website&utm_medium=whatsapp&utm_campaign=wpp-${utmSource}-link`;
}
